import { REGIONS } from 'src/models/developer/Developer'
import Model, { ID, IsoDateTime } from 'src/models/model'

export default class ClientVersion extends Model {
  static name = 'ClientVersion'

  static deletable = true

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      version: {
        type: String,
        default () {
          return new IsoDateTime().format('YYYY..1')
        }
      },
      comparableVersion: {
        type: String,
        output: true
      },
      urgent: {
        type: Boolean,
        default: false
      },
      adminRelated: {
        type: Boolean,
        default: true
      },
      posRelated: {
        type: Boolean,
        default: true
      },
      consumerRelated: {
        type: Boolean,
        default: false
      },
      signageRelated: {
        type: Boolean,
        default: false
      },
      kioskRelated: {
        type: Boolean,
        default: false
      },
      indyOnly: {
        type: Boolean,
        default: false
      },
      regions: {
        type: [String],
        default: () => REGIONS.ALL
      },
      title: {
        type: String,
        default: '<10 Word Unique Feature Description'
      },
      hasReleaseNotes: {
        type: Boolean,
        output: true
      },
      releaseNotes: {
        type: String,
        default: `
        <h3>What's New:</h3>
          <div><ul>
            <li>Quick succinct summary</li>
            <li>Use full sentences</li>
            <li>Keep different features in separate release notes<br></li>
          </ul></div>
        <div><br></div>
        <h3>Why It's Important:</h3>
        <div><br></div>
          <div>A short explanation of why we prioritized this work and how it can benefit cinemas (or moviegoers).</div>
        <div><br></div><div><br></div>
        <h3>Our Solution:</h3>
        <div><br></div>
          <div>A more detailed (1-3 paragraph) overview of the solution with a demo of the solution in action. The demo doesn't have to show every step of using the solution.</div>
          <div><br></div>
          <div>"Tell, show, then tell".</div>
          <div><br></div>
          <h2 align="center">[Embed Loom Demo]<br></h2>
        <div><br></div><div><br></div>
        <h3>How to Get Started:</h3>
          <div><ol>
            <li>Step-by-step instructions for using the feature.</li>
            <li>Include pictures using the "insert image" button in the text editor (don't copy and paste).</li>
            <li>Make sure to watch your spelling and grammar. Be consistent!<br></li>
          </ol></div>
        <div><br></div>`,
        excludeFromDefault: true
      },
      releaseNotesPublished: {
        type: Boolean,
        default: false
      },
      releaseNotesPublishedAt: {
        type: IsoDateTime,
        output: true
      },
      important: {
        type: Boolean,
        default: false
      }
    }
    this.paginate = true
  }

  isUnseen (seenVersion) {
    if (!seenVersion) return true

    return this.comparableVersion > seenVersion
  }

  isComingSoon (comparableVersion) {
    if (!comparableVersion) return false

    return this.comparableVersion > comparableVersion
  }
}
